import { render } from "./editBed.vue?vue&type=template&id=78238052&scoped=true"
import script from "./editBed.vue?vue&type=script&lang=js"
export * from "./editBed.vue?vue&type=script&lang=js"

import "./editBed.vue?vue&type=style&index=0&id=78238052&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78238052"]])

export default __exports__